import workspaceQuery from 'graphql/queries/system/SystemSystemPrinterWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/system/SystemSystemPrinterListQuery.graphql';
import instanceQuery from 'graphql/queries/system/SystemSystemPrinterQuery.graphql';
import defaultQuery from 'graphql/queries/system/SystemSystemPrinterDefault.graphql';
import mutationQuery from 'graphql/mutations/system/SystemSystemPrinterMutation.graphql';
import fragment from 'graphql/fragments/system/SystemSystemPrinterFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SystemSystemPrinter: EntityType = {
  type: 'SystemPrinter',
  title: 'System Printers',
  formTitle: 'System Printer',
  formUrl: '/System/SystemPrinter/Details/',
  workspaceUrl: '/System/SystemPrinter/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'SYSTEM_PRINTER',
};

export default SystemSystemPrinter;
